"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, TableHeader, TableHeaderCell, tv } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useTableHeader } from "@/providers/TableHeaderProvider";
import { useActivityFeedColumns } from "../hooks";
import { ACTIVITY_TABLE_COLUMN_CLASSNAMES } from "../styles";
const isCriteriaOnly = activityTypes => {
  if (!activityTypes || activityTypes.length === 0) {
    return false;
  }
  return activityTypes.every(element => element === "COLLECTION_OFFER" || element === "TRAIT_OFFER");
};
const headerClassNames = tv({
  variants: {
    variant: {
      item: "bg-bg-primary",
      global: "",
      collection: "",
      profile: ""
    }
  }
});
export function ActivityFeedTableHeader(t0) {
  const $ = _c(41);
  const {
    activityTypes,
    className,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "global" : t1;
  const columns = useActivityFeedColumns();
  const {
    className: tableHeaderClassName
  } = useTableHeader();
  const t = useTranslations("ActivityFeedTableHeader");
  let t2;
  if ($[0] !== className || $[1] !== tableHeaderClassName || $[2] !== variant) {
    t2 = classNames(tableHeaderClassName, className, headerClassNames({
      variant
    }));
    $[0] = className;
    $[1] = tableHeaderClassName;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== columns.event || $[5] !== t || $[6] !== variant) {
    t3 = columns.event ? <TableHeaderCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.event({
      variant
    })}>{t("event")}</TableHeaderCell> : null;
    $[4] = columns.event;
    $[5] = t;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== activityTypes || $[9] !== columns.item || $[10] !== t) {
    t4 = columns.item ? <TableHeaderCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.item}>{isCriteriaOnly(activityTypes) ? t("collection") : t("item")}</TableHeaderCell> : null;
    $[8] = activityTypes;
    $[9] = columns.item;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== columns.price || $[13] !== t) {
    t5 = columns.price ? <TableHeaderCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.price}>{t("price")}</TableHeaderCell> : null;
    $[12] = columns.price;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== columns.quantity || $[16] !== t) {
    t6 = columns.quantity ? <TableHeaderCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.quantity}>{t("quantity")}</TableHeaderCell> : null;
    $[15] = columns.quantity;
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== columns.rarity || $[19] !== t) {
    t7 = columns.rarity ? <TableHeaderCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.rarity}>{t("rarity")}</TableHeaderCell> : null;
    $[18] = columns.rarity;
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== columns.from || $[22] !== t) {
    t8 = columns.from ? <TableHeaderCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.from}>{t("from")}</TableHeaderCell> : null;
    $[21] = columns.from;
    $[22] = t;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== columns.to || $[25] !== t) {
    t9 = columns.to ? <TableHeaderCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.to}>{t("to")}</TableHeaderCell> : null;
    $[24] = columns.to;
    $[25] = t;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== columns.time || $[28] !== t || $[29] !== variant) {
    t10 = columns.time ? <TableHeaderCell className={ACTIVITY_TABLE_COLUMN_CLASSNAMES.time({
      variant
    })}>{t("time")}</TableHeaderCell> : null;
    $[27] = columns.time;
    $[28] = t;
    $[29] = variant;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t11 = <TableHeader className={t2}>{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</TableHeader>;
    $[31] = t10;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
}